import { render, staticRenderFns } from "./a-v-datatable-header-row.vue?vue&type=template&id=951a13a4&scoped=true"
import script from "./a-v-datatable-header-row.vue?vue&type=script&lang=js"
export * from "./a-v-datatable-header-row.vue?vue&type=script&lang=js"
import style0 from "./a-v-datatable-header-row.vue?vue&type=style&index=0&id=951a13a4&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "951a13a4",
  null
  
)

export default component.exports